            
<template>  
  <div v-if="createdCycle">
  	<div class="modalsave" v-show="saveConfig.capa"></div>
      <validation-observer v-slot="{ invalid }">       
                <b-form  inline style="margin-bottom:15px" novalidate> 
                  <b-row style="width:100%;margin-bottom:20px" align-v="center">                      
                        <sw-inputs
                          inputTabla="info_egresos"
                          inputCampo="id_datos_razon"
                          inline
                          :md="3" :lg="3">
                        </sw-inputs>                                              
                        <sw-inputs  style="margin-top: -10px;"
                          inputTabla="info_egresos"
                          inputCampo="gastos_menores"
                          inline
                          :md="3" :lg="3">
                        </sw-inputs>                                            
                        <sw-inputs style="margin-top: -10px;"
                          inputTabla="info_egresos"
                          inputCampo="descontar_cuadre"
                          inline
                          :md="3" :lg="3">
                        </sw-inputs>  
                        <b-col :md="3" :lg="3" style="margin-top: -22px;">                          
                          <b-form-group label="Cuadre">
                            <b-form-radio v-model="dataForm[namePath].info_egresos.caja" name="some-radios" value="0">Afiliación</b-form-radio>
                            <b-form-radio v-model="dataForm[namePath].info_egresos.caja" name="some-radios" value="1">Aportes</b-form-radio>
                          </b-form-group>
                        </b-col>       
                  </b-row>  
                  <b-row style="border: 1px dashed #888; width:100%; border-radius:5px; padding:10px 0">
                    <sw-inputs
                      inputTabla="info_egresos"
                      inputCampo="name" 
                      :searchs="['id_list_documento','documento','name']"
                      list="datos_egresos" 
                      inline
                      @buscar="buscarFtn"
                      :md="6" :lg="6">
                    </sw-inputs>  
                    <sw-inputs
                      inputTabla="info_egresos"
                      inputCampo="documento"  
                      inline                   
                      :md="6" :lg="6">
                    </sw-inputs> 
                    <sw-inputs
                      inputTabla="info_egresos"
                      inputCampo="direccion"
                      inline
                      :md="6" :lg="6">
                    </sw-inputs> 
                    <sw-inputs
                      inputTabla="info_egresos"
                      inputCampo="telefonos"
                      inline
                      :md="6" :lg="6">
                    </sw-inputs>  
                  </b-row>  
                  <b-row style="border: 1px dashed #888; width:100%; border-radius:5px; padding:10px 0; margin-top:10px">                   
                    <sw-inputs
                      inputTabla="info_egresos"
                      inputCampo="descripcion"
                      inline
                      :md="9" :lg="9">
                    </sw-inputs>                     
                    <sw-inputs
                      inputTabla="info_egresos"
                      inputCampo="valor"
                      inline
                      :md="3" :lg="3">
                    </sw-inputs>                 
                  </b-row>     
      </b-form>
      <footer  id="modal-1___BV_modal_footer_" class="modal-footer" style="margin: 0 -15px -15px; padding: 0 0 15px">
         <b-row align-v="center" style="width:100%">          
           <b-col v-if="namePath==='informes_egresos'">            
            <sw-saveform
              :index="dataIndex[namePath]"
              nameBtn=""
              :invalid="dataForm[namePath].info_egresos.name===null || dataForm[namePath].info_egresos.name===''"
              @save="save"
              >
            </sw-saveform>
           </b-col>
           <b-col  v-if="namePath==='afiliado_incapacidades'" class="text-right pt-3">  
              <b-form-radio-group
                v-model="pago"
                :options="[{item: 0, name: 'Pago parcial'},{item: 1, name: 'Pago completo'}]"
                class="mb-3"
                value-field="item"
                text-field="name"
                disabled-field="notEnabled"
              ></b-form-radio-group>         
              <b-button  @click="save(false)" 
                variant="success" 
                size="sm" 
                class="ml-2" 
                v-ripple="'rgba(255, 255, 255, 0.10)'" 
              >Guardar Egreso
              </b-button>
          </b-col>
         </b-row>
      </footer>
    </validation-observer>
  </div> 
  <div v-else>
    <sw-loading></sw-loading> 
  </div>
  
</template>
<script>
import { mapState, mapActions } from "vuex"
import { ValidationObserver } from 'vee-validate'
import SwModallistforma  from '@/components/modals/list_forma.vue'
import SwModallistcuentas  from '@/components/modals/list_cuentas.vue'
import SwInputs  from '@/components/forms/inputs.vue'
import SwSaveform from '@/components/forms/saveForm.vue'
import SwLoading from '@/components/notification/loading.vue'
export default 
{
  name: 'swmodalasesores',
  components: {
    SwInputs,
    ValidationObserver,
    SwSaveform,
    SwModallistforma,
    SwModallistcuentas,
    SwLoading  
  },
  props: {
  },
  data()
  {
    return {     
      createdCycle: false,     
      saveEvent:false, 
      pago: 0     
    }
  },
  async updated()
  {    
  },
  async created(){  

    if(this.namePath==='informes_egresos')
    {
    
      let getBackend = await this.getData({route: 'datos_egresos', data: 1})

      const await0 = this.updateDataForm({state: 'info_egresos/fecha', data: this.fecha().fecha.minHoy})
      const await1 = this.updateDataForm({state: 'info_egresos/descripcion', data: null})
      const await2 = this.updateGlobal({state:'openModal/modal/loaded',data:true})
      const await3 = this.updateCrud({state: 'lists/datos_egresos', data: getBackend })
      
      await Promise.all([await0,await1,await2,await3])
      
    }
    if(this.namePath==='afiliado_incapacidades')
    {
      let valor=this.dataGet[this.namePath].data[this.dataIndex[this.namePath]].info_incapacidades.valor;
      for (let index = 0; index <  this.dataGet[this.namePath].data[this.dataIndex[this.namePath]].info_egresos.length; index++) {
        valor = valor- this.dataGet[this.namePath].data[this.dataIndex[this.namePath]].info_egresos[index].valor;        
      }

      const await13 = this.updateDataForm({state: 'info_egresos/valor', data: valor})
      const await14 = this.updateDataForm({state: 'info_incapacidades', data: this.dataGet[this.namePath].data[this.dataIndex[this.namePath]].info_incapacidades})
      const await0 = this.updateDataForm({state: 'info_egresos/fecha', data: this.fecha().fecha.minHoy})
      const await1 = this.updateDataForm({state: 'info_egresos/descripcion', data: 'pago de incapacidad # '+this.dataGet[this.namePath].data[this.dataIndex[this.namePath]].info_incapacidades.incapacidad})
      const await2 = this.updateDataForm({state: 'info_egresos/id_datos_razon', data: this.dataGet[this.namePath].data[this.dataIndex[this.namePath]].info_incapacidades.id_datos_razon})
      const await3 = this.updateDataForm({state: 'info_egresos/name', data: this.gettersDatalist('datos_afiliado',this.dataGet[this.namePath].data[this.dataIndex[this.namePath]].info_incapacidades.id_datos_afiliado)[0].name})
      const await4 = this.updateDataForm({state: 'info_egresos/id_list_documento', data: this.gettersDatalist('datos_afiliado',this.dataGet[this.namePath].data[this.dataIndex[this.namePath]].info_incapacidades.id_datos_afiliado)[0].id_list_documento})
      const await5 = this.updateDataForm({state: 'info_egresos/documento', data: this.gettersDatalist('datos_afiliado',this.dataGet[this.namePath].data[this.dataIndex[this.namePath]].info_incapacidades.id_datos_afiliado)[0].documento})
      const await6 = this.updateDataForm({state: 'info_egresos/direccion', data: this.gettersDatalist('datos_afiliado',this.dataGet[this.namePath].data[this.dataIndex[this.namePath]].info_incapacidades.id_datos_afiliado)[0].direccion})
      const await7 = this.updateDataForm({state: 'info_egresos/telefonos', data: this.gettersDatalist('datos_afiliado',this.dataGet[this.namePath].data[this.dataIndex[this.namePath]].info_incapacidades.id_datos_afiliado)[0].telefonos})
      const await8 = this.updateDataForm({state: 'info_egresos/email', data: this.gettersDatalist('datos_afiliado',this.dataGet[this.namePath].data[this.dataIndex[this.namePath]].info_incapacidades.id_datos_afiliado)[0].email})
      const await9 = this.updateGlobal({state:'openModal/modal/loaded',data:true})
      const await10 = this.updateDataForm({state: 'info_egresos/descontar_cuadre', data: 0})
      const await11 = this.updateDataForm({state: 'info_egresos/caja', data: 1})
      const await12 = this.updateDataForm({state: 'info_egresos/id_info_incapacidades', data: this.dataGet[this.namePath].data[this.dataIndex[this.namePath]].info_incapacidades.id})
      
      await Promise.all([await0,await1,await2,await3,await4,await5,await6,await7,await8,await9,await10,await11,await12,await13,await14])
    }
    this.createdCycle=true
  },
  destroyed()
  {
      this.resetDataIndex()
      this.resetDataPost()
  },
  computed: { 
  },
  methods: {
		...mapActions({			
			assignDataForm: 'crudStore/assignDataForm',
		}),
    async save(event)
    {      
        this.$emit('save',{save:event.save, ftn: 'registroFtn', pago: this.pago})  
        return true 
    },
    async buscarFtn(event)
    {
      let datos_egresos= this.gettersDatalist('datos_egresos',event)[0]

      let info_egresos= { name: datos_egresos.name, direccion: datos_egresos.direccion, documento: datos_egresos.documento, telefonos: datos_egresos.telefonos, email: datos_egresos.email, id_list_documento: datos_egresos.id_list_documento}

      await this.assignDataForm({state: 'info_egresos', data: info_egresos})
    }
  }  
}
</script>
<style>
</style>